import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const ContentShowcase = () => {
  const images = [
    {
      src: "https://static.prod-images.emergentagent.com/jobs/dbc57745-8471-48c9-85cd-c72b1dc9efd4/images/556de8392d110de7f48fa9c1dfadf96b73e5cc7ef53431b73cd4e3bfcb5707d9.png",
      alt: "Instagram content mockup",
      className: "row-span-2"
    },
    {
      src: "https://static.prod-images.emergentagent.com/jobs/dbc57745-8471-48c9-85cd-c72b1dc9efd4/images/e08ae5a070dbc81ed39469c4b257dae6e09867ff7a235ee625608e308aa9f113.png",
      alt: "LinkedIn content mockup",
      className: "row-span-2"
    },
    {
      src: "https://static.prod-images.emergentagent.com/jobs/dbc57745-8471-48c9-85cd-c72b1dc9efd4/images/8cc3fe2bd7c9328d298388f6f9af8297f7685565a04cdd15f627d1aa89859f11.png",
      alt: "Email newsletter mockup",
      className: ""
    }
  ];

  return (
    <section id="content-showcase" className="py-[35px] md:py-20 bg-white" data-testid="content-showcase-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image Gallery */}
          <motion.div 
            className="grid grid-cols-3 gap-4 order-2 lg:order-1"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {images.map((image, index) => (
              <motion.div
                key={index}
                className={`${image.className} overflow-hidden rounded-2xl shadow-lg`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </motion.div>
            ))}
          </motion.div>

          {/* Right - Text Content */}
          <motion.div 
            className="order-1 lg:order-2"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 
              className="text-3xl md:text-4xl font-bold text-slate-800 mb-6"
              style={{ textWrap: 'balance' }}
            >
              Platform-Perfect Content,{' '}
              <span className="bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
                Every Time
              </span>
            </h2>
            
            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              Each piece of content is adapted to the platform — tone, format, and style optimized for engagement. From LinkedIn's professional voice to Instagram's visual-first approach, your brand stays consistent while speaking each platform's language.
            </p>

            <motion.button
              className="px-8 py-4 bg-gradient-to-r from-violet-500 to-pink-500 text-white font-semibold rounded-xl hover:opacity-90 transition-opacity flex items-center gap-2 group shadow-lg shadow-purple-500/30"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Get Early Access
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContentShowcase;
